module.exports = __webpack_public_path__ + "97dc38ff774f8433db37ec4d72b8c530.png";